import { getMonthRange, getPreviousDay, getPreviousMonthRange, getPreviousYearRange, getYearRange } from "@skylab-shared/utils";

export type DateFitlerValueRange = {
	from: Date;
	to: Date;
};

export type DateFilterReturnValues = DateFitlerValueRange & {
	chosenValue?: DateFilterSelectValue | null;
};

export const DateFilterSelectValue = {
	CurrentMonth: 1,
	PreviousMonth: 2,
	PreviousAndCurrentMonth: 3,
	CurrentDay: 4,
	PreviousDay: 5,
	CurrentYear: 6,
	PreviousYear: 7,
	Chosen: 8,
} as const;

export type DateFilterSelectValue = (typeof DateFilterSelectValue)[keyof typeof DateFilterSelectValue];

export function getDateFilterValue(from: Date | null, to: Date | null) {
    return !from || !to ? null : { from: from, to: to };
}

export function getDateRangeBySelectValue(value: DateFilterSelectValue): {from: Date, to: Date} | null {
    const currentDate = new Date();
    const previousDay = getPreviousDay(currentDate);
    const currentMonth = getMonthRange(currentDate);
    const previousMonth = getPreviousMonthRange(currentDate);
    const currentYear = getYearRange(currentDate);
    const previousYear = getPreviousYearRange(currentDate);

    const ranges: Record<Exclude<DateFilterSelectValue, typeof DateFilterSelectValue.Chosen>, { from: Date; to: Date }> = {
        [DateFilterSelectValue.CurrentDay]: { from: currentDate, to: currentDate },
        [DateFilterSelectValue.PreviousDay]: { from: previousDay, to: previousDay },
        [DateFilterSelectValue.CurrentMonth]: { from: currentMonth.firstDay, to: currentMonth.lastDay },
        [DateFilterSelectValue.PreviousMonth]: { from: previousMonth.firstDay, to: previousMonth.lastDay },
        [DateFilterSelectValue.PreviousAndCurrentMonth]: { from: previousMonth.firstDay, to: currentMonth.lastDay },
        [DateFilterSelectValue.CurrentYear]: { from: currentYear.firstDay, to: currentYear.lastDay },
        [DateFilterSelectValue.PreviousYear]: { from: previousYear.firstDay, to: previousYear.lastDay },
    };

    if (value === DateFilterSelectValue.Chosen) {
        return null;
    }
    return ranges[value];
}